/**
 * 第二因子错误码纯函数（2026-09-19-N10 可用性小项 · 3410 文案）
 *
 * 3410 由后端 `SensitiveOperationVerifier#verify` 承载两类语义（同码不同因）：
 * - **未提供任一因子**（已绑 2FA 且 X-OTP/X-Pay-Password 皆空）→ `MFA_OTP_REQUIRED`
 *   （message「2FA 验证码必填」；mock 串 `3410:OTP_REQUIRED`）；
 * - **验证码错误** → `MFA_OTP_INVALID`（message「2FA 验证码校验失败」；mock 串 `3410:OTP_INVALID`）。
 *
 * 前者若套用「验证码不正确」会误导（用户根本没输入），故需区分。
 * 纯函数（无 React / 无 i18next），可被 node 直跑单测。
 */

/** 3410：是否属于「未提供任一因子」语义（→ 二选一完成验证引导，而非「验证码不正确」） */
export function isFactorMissing3410(err: string): boolean {
  if (!err.includes('3410')) {
    return false;
  }
  return (
    err.includes('OTP_REQUIRED') ||
    err.includes('MFA_OTP_REQUIRED') ||
    err.includes('必填')
  );
}

/**
 * 3423：是否属于「未设支付密码」登录门禁语义（LoginSetupGateService）。
 *
 * 持卡人未设支付密码时，非白名单端点（含 GET /cards/{id} 卡详情）被后端拦截，
 * 经 GlobalExceptionHandler 返回 HTTP 200 + 业务码 3423「请先设置支付密码」
 * （PRD：auth-session-api §8B 允许列表外业务读写一律拦截；card-api AC-CARDHOLDER-CARD-009）。
 *
 * 入参对齐 ApiResult 失败态：`code` 单独携带，`error` 为 `code: message` 拼接（client.ts codeMsg），
 * 两者择一命中即判门禁——同时兼容错误码名（PAY_PASSWORD_NOT_SET）与 message 关键字（支付密码）。
 */
export function isPayPasswordGate(code?: string, error?: string): boolean {
  const blob = `${code || ''} ${error || ''}`;
  return (
    blob.includes('3423') ||
    blob.includes('支付密码') ||
    /PAY[_\s-]?PASSWORD_NOT_SET/i.test(blob)
  );
}
